<template>
  <div>
    <!-- SHM Config -->
    <b-row>
      <b-col class="align-left">
        <p>Parámetros generales usados para el cálculo SHM</p>
        <div v-for="(sensor, index) in selectedGroup.sensor" :key="index">
          <SHMConfigEdit
            class="groupBox"
            v-if="sensor.isShm"
            :sensor="sensor"
            :save="toggleVar"
          />
        </div>
      </b-col>
    </b-row>
    <!-- SHM Config -->

    <!-- SHM Config -->
    <b-row style="margin-top: 10px">
      <b-col>
        <form-button
          label="Guardar configuracion"
          customType="submit"
          v-bind:block="true"
          @click="saveConfig"
        />
      </b-col>
      <b-col>
        <!-- DUMMY -->
      </b-col>    
      <b-col>
        <!-- DUMMY -->
      </b-col>      
    </b-row>
    <!-- SHM Config -->
  </div>
</template>


<script>
import SHMConfigEdit from "./SHMConfigEdit";
import Button from "@/components/common/form/Button";

export default {
  data() {
    return {
      requestedGroup: null,
      selectedGroup: {
        sensor: null
      },
      toggleVar: false
    };
  },
  components: {
    SHMConfigEdit,
    "form-button": Button,
  },
  methods: {
    async requestSHMGroupSensors(groupData) {
      this.selectedGroup = [];
      //en groupData viene el grupo y los sensores asociados
      this.selectedGroup = groupData;
    },

    saveConfig(){
        this.toggleVar = !this.toggleVar
    }
  },
};
</script>


<style scoped>
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
  margin-bottom: 20px;
}

.innergroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}

.innergroupBoxAlt {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 10px;
}

.titulo1 {
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}
</style>
